import colors from './colors';
import fonts from './fonts';
import sizes from './sizes';

const { fixedSpacing } = sizes;

/**
 * Notifications theme generator function
 * @param {object} params - Theme parameters
 * @param {boolean} params.darkMode - Whether dark mode is enabled
 * @param {boolean} params.mobile - Whether mobile mode is enabled
 * @param {number} params.width - Screen width
 * @param {number} params.height - Screen height
 * @returns {object} Notifications theme object
 */
// @ts-ignore
const notificationsTheme = ({ darkMode, mobile, width, height }) => {
    const maxWidth = mobile ? Math.min(width * 0.9, 300) : 357;
    const minWidth = mobile ? Math.min(width * 0.8, 280) : 318;
    const maxHeight = mobile ? Math.min(height * 0.9, 480) : 480;

    return {
        maxWidth,
        minWidth,
        maxHeight,
        maxWidthOnMobile: 300,
        gap: fixedSpacing.md,
        lineHeight: 20,
        header: {
            iconSize: 16,
            button: {
                marginLeft: fixedSpacing.md
            },
            buttonBar: {
                padding: `${fixedSpacing.xl}px ${fixedSpacing.xl}px ${fixedSpacing.lg}px ${fixedSpacing.xl}px`
            },
            title: {
                color: darkMode ? colors.coolGray100 : colors.coolGray900,
                font: fonts.text.md.semiBold,
                mobile: {
                    padding: 0,
                    paddingLeft: fixedSpacing.xl,
                    paddingRight: fixedSpacing.xl,
                    fontWeight: 'bold',
                    maxWidth: maxWidth - 40 // Constraint title width
                }
            },
            actionButton: {
                icon: 'check-circle',
                font: mobile ? fonts.text.sm.semiBold : fonts.text.xs.semiBold,
                color: darkMode ? colors.primary300 : colors.primary600
            },
            filterButton: {
                icon: 'expand-more',
                color: darkMode ? colors.coolGray300 : colors.coolGray600,
                font: mobile ? fonts.text.sm.regular : fonts.text.xs.regular
            }
        },
        row: {
            iconSize: 20,
            padding: `${fixedSpacing.lg}px ${fixedSpacing.xl}px`,
            transition: 'background-color 0.2s',
            removeButton: {
                opacity: mobile ? 1 : 0,
                color: darkMode ? colors.coolGray300 : colors.coolGray600,
                transition: 'opacity 0.2s, background-color 0.2s, color 0.2s'
            },
            message: {
                font: fonts.text.sm.regular,
                color: darkMode ? colors.coolGray100 : colors.coolGray700,
                container: {
                    padding: 0
                }
            }
        },
        timeAgo: {
            font: fonts.text.xs.regular,
            color: darkMode ? colors.coolGray400 : colors.coolGray500,
            marginTop: fixedSpacing.md
        },
        unreadIndicator: {
            containerWidth: fixedSpacing.lg,
            size: 8,
            color: colors.primary600
        },
        emptyState: {
            margin: fixedSpacing.xl,
            fontSize: fonts.text.sm.regular.fontSize
        }
    };
};

export default notificationsTheme;
